<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      :left-arrow="true"
      :z-index="10"
      :title="userInfo.payPwd == null ? '设置密码' : '修改密码'"
      @click-left="goableBack()"></van-nav-bar>
    <div class="contain">
      <van-cell-group class="group" v-if="userInfo.payPwd == null">
        <van-field
          v-model="settingPwd.payPwd"
          type="password"
          :formatter="formatter"
          clearable
          maxlength="6"
          label="输入密码"
          placeholder="请输入密码" />
        <van-field
          v-model="settingPwd.confirmPwd"
          type="password"
          :formatter="formatter"
          clearable
          maxlength="6"
          label="确认密码"
          placeholder="请再次输入密码" />
      </van-cell-group>
      <van-cell-group class="group" v-else>
        <van-field
          v-model="userInfo.phone"
          maxlength="11"
          label="手机号"
          placeholder="请输入手机号"
          clearable
          :readonly="true" />
        <van-field
          v-model="modifyPwd.code"
          type="number"
          clearable
          maxlength="6"
          label="验证码"
          placeholder="请输入验证码">
          <!-- <template #button> -->
          <van-button
            class="code-btn"
            :loading="smsForm.loading"
            loading-text="发送中..."
            @click="onSMSSend"
            plain
            :disabled="isSendSMSEnable"
            slot="button"
            size="small"
            type="primary"
            >{{ getSendBtnText }}</van-button
          >
          <!-- </template> -->
        </van-field>
        <van-field
          v-model="modifyPwd.payPwd"
          type="password"
          :formatter="formatter"
          clearable
          maxlength="6"
          label="新密码"
          placeholder="请输入新密码" />
        <van-field
          v-model="modifyPwd.confirmPwd"
          type="password"
          :formatter="formatter"
          clearable
          maxlength="6"
          label="确认密码"
          placeholder="请确认新密码" />
      </van-cell-group>
      <van-button
        class="btn"
        color="rgb(206, 29, 35)"
        round
        type="warning"
        @click="onSureAction"
        v-preventReClick
        >{{ userInfo.payPwd == null ? "确认密码" : "确认修改" }}</van-button
      >
    </div>
    <!-- 添加图片滑动解锁 -->
    <PhotoSlide
      ref="slideblock"
      @success="onSlideSuccess"
      sliderText="向右滑"
      :show="false"
      :showSlidePop.sync="showSlidePop"></PhotoSlide>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import * as CustApi from "@/api/cust"
import { CellGroup, Field } from "vant"
import * as PayPassword from "@/api/payPassword"
import PhotoSlide from "../../components/photoSlide.vue"
// import MD5 from "blueimp-md5"

export default {
  name: "settingPwd",
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    PhotoSlide
  },
  data() {
    return {
      showSlidePop: false, // 是否显示滑块解锁框
      smsForm: {
        loading: false,
        smsCountDown: 0,
        smsInterval: null
      },
      settingPwd: {
        payPwd: "",
        confirmPwd: ""
      },
      modifyPwd: {
        code: "",
        payPwd: "",
        confirmPwd: ""
      }
    }
  },
  computed: {
    isSendSMSEnable() {
      return this.smsForm.smsCountDown !== 0
    },
    getSendBtnText() {
      if (this.smsForm.smsCountDown > 0) {
        return this.smsForm.smsCountDown
      } else {
        return "获取验证码"
      }
    }
  },
  beforeDestroy() {
    if (this.smsForm.smsInterval) {
      clearInterval(this.smsForm.smsInterval)
    }
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    formatter(value) {
      //  过滤输入的非数字
      return value.replace(/[^\d]/g, "")
    },
    //滑块验证方法
    onSlideSuccess() {
      this.showSlidePop = false
      this.onSendCode()
    },
    //请求验证码接口
    onSendCode() {
      this.smsForm.loading = true
      CustApi.sendcodeWithout()
        .then((data) => {
          this.smsForm.loading = false
          this.startSMSTimer()
        })
        .catch((e) => {
          this.smsForm.loading = false
          Toast(e.msg || e.message)
        })
    },
    onSMSSend() {
      if (this.userInfo.phone) {
        this.showSlidePop = true
      } else {
        this.$toast("暂无手机号")
      }
    },
    startSMSTimer() {
      this.smsForm.smsCountDown = 60
      this.smsForm.smsInterval = setInterval(() => {
        this.smsForm.smsCountDown--
        if (this.smsForm.smsCountDown <= 0) {
          clearInterval(this.smsForm.smsInterval)
        }
      }, 1000)
    },
    payPwd() {
      if (this.settingPwd.payPwd.length < 6) {
        this.$toast("请输入6位密码")
        return
      }
      if (this.settingPwd.confirmPwd.length < 6) {
        this.$toast("请输入6位确认密码")
        return
      }
      if (this.settingPwd.payPwd != this.settingPwd.confirmPwd) {
        this.$toast("两次输入的密码不一致")
        return
      }
      // this.settingPwd.payPwd = MD5(this.settingPwd.payPwd)
      // this.settingPwd.confirmPwd = MD5(this.settingPwd.confirmPwd)
      PayPassword.payPwd(this.settingPwd)
        .then((data) => {
          if (data) {
            this.getUserInfo()
            this.goableBack()
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    payPwdReset() {
      if (!this.userInfo.phone) {
        this.$toast("暂无手机号")
        return
      }
      if (this.modifyPwd.code.length < 6) {
        this.$toast("请输入6位验证码")
        return
      }
      if (this.modifyPwd.payPwd.length < 6) {
        this.$toast("请输入6位新密码")
        return
      }
      if (this.modifyPwd.confirmPwd.length < 6) {
        this.$toast("请输入6位确认密码")
        return
      }
      if (this.modifyPwd.payPwd != this.modifyPwd.confirmPwd) {
        this.$toast("两次输入的密码不一致")
        return
      }
      // this.modifyPwd.payPwd = MD5(this.modifyPwd.payPwd)
      // this.modifyPwd.confirmPwd = MD5(this.modifyPwd.confirmPwd)
      PayPassword.payPwdReset(this.modifyPwd)
        .then((data) => {
          if (data) {
            this.getUserInfo()
            this.goableBack()
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    onSureAction() {
      if (!this.userInfo.payPwd) {
        this.payPwd()
      } else {
        this.payPwdReset()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  min-height: calc(100vh - 45px);
  background-color: white;
  overflow: hidden;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0px 0;
}
.group {
  margin: 50px 20px;
  .van-field {
    font-size: 15px;
  }
  .code-btn {
    color: rgb(206, 29, 35);
    background-color: white;
    border: 0px;
  }
}
.btn {
  margin: 0 20px;
  height: 44px;
  width: calc(100vw - 40px);
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
}
</style>
